import { render, staticRenderFns } from "./ParentLinksForClients.vue?vue&type=template&id=2c4a4031"
import script from "./ParentLinksForClients.vue?vue&type=script&lang=js"
export * from "./ParentLinksForClients.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports